import { NavLink } from 'react-router-dom';
import { Home, Compass, Search, Bookmark, Moon, Sun, ArrowUp, PlaySquare } from 'lucide-react';
import { cn } from '../lib/utils';
import { useTheme } from './ThemeProvider';

export function BottomNav() {
  const { theme, toggleTheme } = useTheme();

  const handleBackToTop = () => {
    document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navItems = [
    { name: 'হোম', path: '/', icon: Home, isLink: true },
    { name: 'সার্চ', path: '/search', icon: Search, isLink: true },
    { name: 'শর্টস', path: '/shorts', icon: PlaySquare, isLink: true },
    { name: 'সেভ', path: '/bookmarks', icon: Bookmark, isLink: true },
    { name: 'ডার্ক', isThemeMenu: true, icon: theme === 'dark' ? Sun : Moon },
  ];

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#FFFFFF] dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800 pb-safe">
      <nav className="flex justify-around items-center h-14 w-full max-w-md mx-auto px-1">
        {navItems.map((item, index) => {
          if ('isLink' in item && item.isLink) {
            return (
              <NavLink
                key={item.path}
                to={item.path!}
                className={({ isActive }) =>
                  cn(
                    "flex flex-col items-center justify-center w-full space-y-1 transition-colors active:scale-95",
                    isActive ? "text-[#D32F2F]" : "text-[#666666] hover:text-[#111111] dark:text-gray-400 dark:hover:text-gray-50"
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                    <span className="text-[10px] font-medium font-bengali">{item.name}</span>
                  </>
                )}
              </NavLink>
            );
          }

          if ('isThemeMenu' in item && item.isThemeMenu) {
            return (
              <button
                key="theme"
                onClick={toggleTheme}
                className="flex flex-col items-center justify-center w-full space-y-1 transition-colors active:scale-95 text-[#666666] hover:text-[#111111] dark:text-gray-400 dark:hover:text-gray-50"
              >
                <item.icon size={20} strokeWidth={2} />
                <span className="text-[10px] font-medium font-bengali">
                  {theme === 'dark' ? 'লাইট' : 'ডার্ক'}
                </span>
              </button>
            );
          }
          
          return null;
        })}
      </nav>
    </div>
  );
}
